<template>
  <div>
    <Headline :level="2">会員情報</Headline>
    <div class="form-group">
      <label class="confirm">会員番号</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.cmc_no | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">お名前(漢字)</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.name | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">お名前(フリガナ)</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.name_kana | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">お名前(ローマ字)</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.name_romaji | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">メールアドレス</label>
      <p class="text-paragraph text-break" v-if="customer.groomBride">{{ customer.groomBride.mail | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">可能先電話番号</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ groomBrideTel | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">生年月日</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.birth_date | formatDate | with-empty }}</p>
    </div>
    <div class="form-group" v-if="customer.groomBride && customer.groomBride.attribute === '1' && !customer.groomBride.divorce">
      <label class="confirm">ご結婚記念日</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.wedding_anniversary_date | formatDate | with-empty }}</p>
    </div>
    <Headline :level="3">住所(現住所)</Headline>
    <div class="form-group account_address1">
      <p class="text-paragraph account_address1_text" v-if="customer.groomBride">{{ address1 | with-empty }}</p>
    </div>
    <Headline :level="3">住所(新居)</Headline>
    <div class="form-group account_address2">
      <p class="text-paragraph account_address2_text" v-if="customer.groomBride">{{ address2 | with-empty }}</p>
    </div>
    <Headline :level="3">その他</Headline>
    <div class="form-group">
      <label class="confirm">勤務先(会社名)</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.business_place | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">勤務先(部署)</label>
      <p class="text-paragraph" v-if="customer.groomBride">{{ customer.groomBride.unit | with-empty }}</p>
    </div>
    <ChildInfo v-if="childInfoFlag"
      :edit="false"
      :child-info="childInfo"
      :child-info-flag="childInfoFlag"
    />

    <template>
      <Headline :level="2">親御様情報</Headline>
      <Headline :level="3">父親</Headline>
      <div class="form-group">
        <label class="confirm">お名前(漢字)</label>
        <p class="text-paragraph" v-if="customer.father">{{ customer.father.name | with-empty }}</p>
      </div>
      <div class="form-group">
        <label class="confirm">お名前(フリガナ)</label>
        <p class="text-paragraph" v-if="customer.father">{{ customer.father.name_kana | with-empty }}</p>
      </div>
      <div class="form-group">
        <label class="confirm">生年月日</label>
        <p class="text-paragraph" v-if="customer.father">{{ customer.father.birth_date | formatDate | with-empty }}</p>
      </div>
      <div class="form-group">
        <label class="confirm">電話番号</label>
        <ul class="tel-list" v-if="customer.father">
          <li
            v-for="(tel, index) in fatherTel"
            :key="`tel${index}`"
          >
          {{ tel | with-empty }}
          </li>
        </ul>
      </div>
    </template>

    <template>
      <Headline :level="3">母親</Headline>
      <div class="form-group">
        <label class="confirm">お名前(漢字)</label>
        <p class="text-paragraph" v-if="customer.mother">{{ customer.mother.name | with-empty }}</p>
      </div>
      <div class="form-group">
        <label class="confirm">お名前(フリガナ)</label>
        <p class="text-paragraph" v-if="customer.mother">{{ customer.mother.name_kana | with-empty }}</p>
      </div>
      <div class="form-group">
        <label class="confirm">生年月日</label>
        <p class="text-paragraph" v-if="customer.mother">{{ customer.mother.birth_date | formatDate | with-empty }}</p>
      </div>
      <div class="form-group">
        <label class="confirm">電話番号</label>
        <ul class="tel-list" v-if="customer.mother">
          <li
            v-for="(tel, index) in motherTel"
            :key="`tel${index}`"
          >
          {{ tel | with-empty }}
          </li>
        </ul>
      </div>
      <div class="form-group">
        <label class="confirm">住所</label>
        <p class="text-paragraph" v-if="customer.parentAddress">{{ parentAddress | with-empty }}</p>
      </div>
    </template>

    <template v-if="customer.groomBride && customer.groomBride.shipments.length > 0">
      <Headline :level="2">配信メール情報</Headline>
      <template v-if="sendMails.length > 0">
        <Headline :level="3">受け取る情報</Headline>
        <div class="form-group">
          <ul class="check-list">
            <li
              class="check-list-item"
              v-for="(mail, index) in sendMails"
              :key="`ship-yes-${index}`"
            >
              {{ mail.name }}
            </li>
          </ul>
        </div>
      </template>
      <template v-if="notSendMails.length > 0">
        <Headline :level="3">受け取らない情報</Headline>
        <div class="form-group">
          <ul class="check-list">
            <li
              class="check-list-item"
              v-for="(mail, index) in notSendMails"
              :key="`ship-no-${index}`"
            >
              {{ mail.name }}
            </li>
          </ul>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import withEmpty from '@/filters/with-empty'
import { formatDate } from '@/filters/format-date'
import ChildInfo from '@/components/ChildInfo'

// お客様情報編集 確認画面
export default {
  props: {
    customer: {
      type: Object,
      required: true
    },
    childInfoFlag: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ChildInfo
  },
  data() {
    return {
      brideTel: this.customer.brideTel,
    }
  },
  computed: {
    groomBrideTel() {
      const tel1 = this.customer.groomBride[`tel${this.customer.groomBride.telPriorityNo}_area_no`]
      const tel2 = this.customer.groomBride[`tel${this.customer.groomBride.telPriorityNo}_local_no`]
      const tel3 = this.customer.groomBride[`tel${this.customer.groomBride.telPriorityNo}_no`]

      return (tel1 && tel2 && tel3) ? `${tel1}-${tel2}-${tel3}` : ''
    },
    childInfo() {
      let childInfo = [];
      for (let child = 1; child <= 5; child++) {
        childInfo.push({
          'sex': this.customer.groomBride.child_info[`child${child}_sex`],
          'year': this.customer.groomBride.child_info[`child${child}_year`],
          'month': this.customer.groomBride.child_info[`child${child}_month`],
        })
      }
      return childInfo
    },
    fatherTel() {
      let telNumber = []
      let tel1 = ''
      let tel2 = ''
      let tel3 = ''

      for (let i = 1; i <= 3; i++) {
        tel1 = this.customer['father'][`tel${i}_area_no`]
        tel2 = this.customer['father'][`tel${i}_local_no`]
        tel3 = this.customer['father'][`tel${i}_no`]

        telNumber.push((tel1 && tel2 && tel3) ? `${tel1}-${tel2}-${tel3}` : '')
      }
      return telNumber;
    },
    motherTel() {
      let telNumber = []
      let tel1 = ''
      let tel2 = ''
      let tel3 = ''

      for (let i = 1; i <= 3; i++) {
        tel1 = this.customer['mother'][`tel${i}_area_no`]
        tel2 = this.customer['mother'][`tel${i}_local_no`]
        tel3 = this.customer['mother'][`tel${i}_no`]

        telNumber.push((tel1 && tel2 && tel3) ? `${tel1}-${tel2}-${tel3}` : '')
      }
      return telNumber;
    },
    address1() {
      const {
        address1_postcode1: zipcode1,
        address1_postcode2: zipcode2,
        address1_billing_state: prefecture,
        address1_billing_city: city,
        address1_billing_street: town,
        address1_building_name: building
      } = this.customer.groomBride

      const zip = (zipcode1 && zipcode2) ? `〒${zipcode1}-${zipcode2} ` : ''

      return `${zip}${prefecture}${city}${town}${building}`
    },
    address2() {
      const {
        address2_postcode1: zipcode1,
        address2_postcode2: zipcode2,
        address2_billing_state: prefecture,
        address2_billing_city: city,
        address2_billing_street: town,
        address2_building_name: building
      } = this.customer.groomBride

      const zip = (zipcode1 && zipcode2) ? `〒${zipcode1}-${zipcode2} ` : ''

      return `${zip}${prefecture}${city}${town}${building}`
    },
    parentAddress() {
      const {
        address1_postcode1: zipcode1,
        address1_postcode2: zipcode2,
        address1_billing_state: prefecture,
        address1_billing_city: city,
        address1_billing_street: town,
        address1_building_name: building
      } = this.customer.parentAddress

      const zip = (zipcode1 && zipcode2) ? `〒${zipcode1}-${zipcode2} ` : ''

      return `${zip}${prefecture}${city}${town}${building}`
    },
    // 受け取る情報
    sendMails() {
      return this.customer.groomBride.shipments.filter(shipment => shipment.value)
    },
    // 受け取らない情報
    notSendMails() {
      return this.customer.groomBride.shipments.filter(shipment => !shipment.value)
    }
  },
  filters: {
    withEmpty,
    formatDate
  }
}
</script>
